// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r9byH{align-items:center;display:flex;justify-content:center;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `r9byH`
};
module.exports = ___CSS_LOADER_EXPORT___;
